import { ThemeColors } from '~/themes/colors'

export interface DropdownColors {
  Background: {
    Default: ThemeColors
    Hover: ThemeColors
    Active: ThemeColors
    Disabled: ThemeColors
  }
  Border: {
    Default: ThemeColors
    Hover: ThemeColors
    Active: ThemeColors
  }
  BoxShadow: ThemeColors
  FontColor: ThemeColors
  Window: {
    Background: ThemeColors
    Border: ThemeColors
    BoxShadow: ThemeColors
  }
  Items: {
    FontColor: ThemeColors
    Background: {
      Default: ThemeColors
      Hover: ThemeColors
      Selected: ThemeColors
      Active: ThemeColors
    }
  }
  Icon: ThemeColors
}

export const dropdownColors: DropdownColors = {
  Background: {
    Default: {
      default: 'gray.100',
    },
    Hover: {
      default: 'white',
    },
    Active: {
      default: 'white',
    },
    Disabled: {
      default: 'gray.100',
    },
  },
  Border: {
    Default: {
      default: 'gray.600',
    },
    Hover: {
      default: 'gray.600',
    },
    Active: {
      default: 'gray.600',
    },
  },
  BoxShadow: {
    default: 'mask.gray.1300.20',
  },
  FontColor: {
    default: 'gray.1300',
  },
  Window: {
    Background: {
      default: 'gray.100',
    },
    Border: {
      default: 'gray.800',
    },
    BoxShadow: {
      default: 'mask.black.20',
    },
  },
  Items: {
    FontColor: {
      default: 'gray.1300',
    },
    Background: {
      Default: {
        default: 'gray.100',
      },
      Hover: {
        default: 'gray.300',
      },
      Selected: {
        default: 'gray.300',
      },
      Active: {
        default: 'gray.400',
      },
    },
  },
  Icon: {
    default: 'gray.1300',
  },
}
